import React, {useState} from 'react';
import Typography from "@mui/material/Typography";
import {Accordion, AccordionDetails, AccordionSummary} from "@mui/material";
import Box from "@mui/material/Box";
import {CheckCircle, ExpandMore} from "@mui/icons-material";
import {Trans, useTranslation} from "react-i18next";
import NewAddress from "./NewAddress";
import ShowBillingAddress from "./ShowBillingAddress";
import SelectSavedAddress from "./SelectSavedAddress";
import CartManager from "../../../managers/cartManager/cartManager";
import AddressShowBox from "./AddressShowBox";
import UserManager, {useUser} from "../../../managers/userManager/userManager";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const addressTypes = ['billing', 'new'];
const addressTypesForUser = ['saved'];

function ShippingAtAddress() {
    const user = useUser();
    const shipping = CartManager.getShipping();
    const {t} = useTranslation();

    const [selectedAddress, setSelectedAddress] = useState(null);

    const onSubmit = (addressType) => {
        CartManager.submitAddress(addressType);
        setSelectedAddress(false, addressType);
    }

    const viewPicker = {
        new: () => <NewAddress onSubmit={() => onSubmit('new')}/>,
        billing: () => <ShowBillingAddress onSubmit={() => onSubmit('billing')}/>,
        saved: () => <SelectSavedAddress addresses={UserManager.getSavedAddresses() || {}}
                                         onSubmit={() => onSubmit('saved')}/>
    }

    // Function to handle address selection
    const handleSelection = (expanded, addressType) => {
        if (expanded) {
            setSelectedAddress(addressType);
        } else {
            setSelectedAddress(null);
        }
    };

    const showSavedPage = () => {
        return user.uid && Object.keys(UserManager.getSavedAddresses() || {}).length;
    }

    const onAddressSaveCheckBoxChange = (event) => {
        return CartManager.handleSaveAddressCheckboxChange(event.target.checked);
    }


    return (
        <Box>
            {shipping.submitted ? <Box>
                <AddressShowBox address={shipping.address}/>
                {(UserManager.getUser() && shipping.addressType !== 'saved') ? <FormControlLabel
                    sx={{px: 3, pb: 2}}
                    control={<Checkbox name="saveAddress" value="yes"/>}
                    label={t('addressForm.saveAddress')}
                    onChange={onAddressSaveCheckBoxChange}
                    checked={CartManager.getShipping().saveAddress}
                /> : ''}
            </Box> : ''}
            {([]).concat(showSavedPage() ? addressTypesForUser : []).concat(addressTypes).map(key => {
                return <Accordion key={key} expanded={selectedAddress === key}
                                  onChange={(event, expanded) => handleSelection(expanded, key)}>
                    <AccordionSummary
                        expandIcon={<ExpandMore/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography sx={{fontWeight: 500}}><Trans i18nKey={`shippingForm.address.${key}`}/></Typography>
                        {(shipping.submitted && shipping.addressType === key) ?
                            <CheckCircle color="primary" sx={{pl: 1}}/> : ''}
                    < /AccordionSummary>
                    <AccordionDetails>
                        {viewPicker[key]()}
                    </AccordionDetails>
                </Accordion>;
            })}
        </Box>
    );
}

export default ShippingAtAddress;
